import { apiClient } from './client.js';
import type { CustomerMembership, Gym, MembershipPlan, MembershipTenant, Tenant } from '@atomfit/shared';

export interface MyMembership extends CustomerMembership {
  remainingGuestPasses: number;
  tenant: Pick<Tenant, 'id' | 'name' | 'slug'> & {
    gyms: Pick<Gym, 'id' | 'name' | 'slug' | 'city' | 'addressLine1'>[];
  };
  plan: MembershipPlan;
}

export interface CreateMembershipPurchaseResponse {
  purchaseId: string;
  subscriptionId?: string;
  stripeAccountId: string | null;
  clientSecret: string | null;
  customerSessionClientSecret: string | null;
}

export const membershipsApi = {
  tenants: () => apiClient.get<{ data: MembershipTenant[] }>('/memberships/tenants'),
  getPurchase: (purchaseId: string) => apiClient.get<{
    id: string; status: string; amountInSmallestUnit: number; currency: string;
    plan: { tier: 'BASIC' | 'PREMIUM' | 'ELITE' };
  }>(`/memberships/purchases/${encodeURIComponent(purchaseId)}`),
  plans: () =>
    apiClient.get<{ data: MembershipPlan[] }>('/memberships/plans'),

  plansByGym: (gymId: string) =>
    apiClient.get<{ data: MembershipPlan[] }>('/memberships/plans', { params: { gymId } }),

  my: () => apiClient.get<{ data: MyMembership[] }>('/memberships/my'),

  purchase: (planId: string, tenantId: string, savePaymentMethod = false) =>
    apiClient.post<CreateMembershipPurchaseResponse>('/memberships/purchase', {
      planId,
      tenantId,
      savePaymentMethod,
    }),

  confirm: (subscriptionId: string) =>
    apiClient.post<{ data: MyMembership | null }>('/memberships/confirm', { subscriptionId }),

  cancel: (membershipId: string) =>
    apiClient.post<{ data: CustomerMembership }>(`/memberships/${membershipId}/cancel`),
};
